"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.set = exports.remove = exports.get = void 0;
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var Cookies = require("js-cookie");
var utilities_1 = require("../utilities");
function get(name, isJSON) {
    return isJSON ? Cookies.getJSON(name) : Cookies.get(name);
}
exports.get = get;
function remove(name, expiration) {
    Cookies.remove(name, {
        expires: expiration, path: '/', domain: utilities_1.getDomain()
    });
}
exports.remove = remove;
function set(name, cookieValue, expiration) {
    var result;
    var options;
    if (firefly_utilities_helper_ts_1.isNumber(expiration)) {
        options = { path: '/', domain: utilities_1.getDomain(), expires: expiration };
    }
    else {
        options = { path: '/', domain: utilities_1.getDomain() };
    }
    if (firefly_utilities_helper_ts_1.isString(name) && !utilities_1.isEmptyString(name)) {
        result = Cookies.set(name, cookieValue, options);
    }
    return result;
}
exports.set = set;
